/**
 * @maintainer Boris Cherepanov (boris.cherepanov@leroymerlin.ru)
 */

/**
 * Dynamic Yield
 */
export const DY_CURRENCY = 'RUB';

/**
 * Dynamic Yield Events
 *
 * для глобального вызова
 */

// Cart
export const DY_ADD_TO_CART = 'DY:add_to_cart';
export const DY_REMOVE_FROM_CART = 'DY:remove_from_cart';
export const DY_SYNC_CART = 'DY:sync_cart';

// Wishlist
export const DY_ADD_TO_WISHLIST = 'DY:add_to_wishlist';

// Filtering & Sorting
export const DY_FILTER_ITEMS = 'DY:filter_items';
export const DY_SORT_ITEMS = 'DY:sort_items';

// Search
export const DY_KEYWORD_SEARCH = 'DY:keyword_search';

// Order/Purchase
export const DY_PURCHASE = 'DY:purchase';

/**
 * @description Переменная хранит сзязку глобального события, события вендора и имя события вендрора
 * @type Record<string, { eventType: string, name: string }>
 */
export const dyEventByName = {
  [DY_ADD_TO_CART]: {
    eventType: 'add-to-cart-v1',
    name: 'Add to Cart',
  },
  [DY_REMOVE_FROM_CART]: {
    eventType: 'remove-from-cart-v1',
    name: 'Remove from Cart',
  },
  [DY_SYNC_CART]: {
    eventType: 'sync-cart-v1',
    name: 'Sync cart',
  },
  [DY_ADD_TO_WISHLIST]: {
    eventType: 'add-to-wishlist-v1',
    name: 'Add to Wishlist',
  },
  [DY_FILTER_ITEMS]: {
    eventType: 'filter-items-v1',
    name: 'Filter Items',
  },
  [DY_SORT_ITEMS]: {
    eventType: 'sort-items-v1',
    name: 'Sort Items',
  },
  [DY_KEYWORD_SEARCH]: {
    eventType: 'keyword-search-v1',
    name: 'Keyword Search',
  },
  [DY_PURCHASE]: {
    eventType: 'purchase-v1',
    name: 'Purchase',
  },
};

/**
 * Имя переменной в sessionStorage
 * для отслеживания необходимости
 * синхронизировать корзину
 * SS - sessionStorage
 * Может быть null, строка true | false
 */
export const DY_SS_CART_SYNC_NECESSARY = 'DY_SS_CART_SYNC_NECESSARY';
